var TJS_1_0_Module_Factory = function () {
  var TJS_1_0 = {
    n: 'TJS_1_0',
    dens: 'http:\/\/www.opengis.net\/tjs\/1.0',
    deps: ['OWS_1_1_0'],
    tis: [{
        ln: 'BoundingCoordinates',
        tn: null,
        ps: [{
            n: 'north',
            rq: true,
            en: 'North',
            ti: 'Decimal'
          }, {
            n: 'south',
            rq: true,
            en: 'South',
            ti: 'Decimal'
          }, {
            n: 'east',
            rq: true,
            en: 'East',
            ti: 'Decimal'
          }, {
            n: 'west',
            rq: true,
            en: 'West',
            ti: 'Decimal'
          }]
      }, {
        ln: 'FrameworkDatasetDescribeDataType',
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }, {
            n: 'describeDatasetsRequest',
            rq: true,
            en: 'DescribeDatasetsRequest',
            ti: '.DescribeDatasetsRequest'
          }, {
            n: 'dataset',
            rq: true,
            col: true,
            en: 'Dataset',
            ti: '.FrameworkDatasetDescribeDataType.Dataset'
          }]
      }, {
        ln: 'Mechanism',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            en: 'Identifier'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract'
          }, {
            n: 'reference',
            rq: true,
            en: 'Reference'
          }]
      }, {
        ln: 'JoinDataResponse.DataInputs',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            en: 'Framework',
            ti: '.FrameworkDatasetDescribeDataType'
          }]
      }, {
        ln: 'Rowset.Row.V',
        tn: null,
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'aid',
            an: {
              lp: 'aid'
            },
            t: 'a'
          }, {
            n: '_null',
            ti: 'Boolean',
            an: {
              lp: 'null'
            },
            t: 'a'
          }]
      }, {
        ln: 'GetDataRequest',
        tn: null,
        ps: [{
            n: 'href',
            rq: true,
            an: {
              lp: 'href',
              ns: 'http:\/\/www.w3.org\/1999\/xlink'
            },
            t: 'a'
          }]
      }, {
        ln: 'OutputStylingsType',
        ps: [{
            n: 'styling',
            rq: true,
            col: true,
            en: 'Styling',
            ti: '.Styling'
          }]
      }, {
        ln: 'Columnset',
        tn: null,
        ps: [{
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.Columnset.FrameworkKey'
          }, {
            n: 'attributes',
            rq: true,
            en: 'Attributes',
            ti: '.Columnset.Attributes'
          }]
      }, {
        ln: 'MeasureCountExceptions.Null',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            en: 'Identifier'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }]
      }, {
        ln: 'FrameworkKey',
        tn: null,
        ps: [{
            n: 'column',
            rq: true,
            col: true,
            en: 'Column',
            ti: '.FrameworkKey.Column'
          }]
      }, {
        ln: 'DescribeFrameworkKeyType',
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }, {
            n: 'rowset',
            rq: true,
            en: 'Rowset',
            ti: '.DescribeFrameworkKeyType.Rowset'
          }]
      }, {
        ln: 'Rowset',
        tn: null,
        ps: [{
            n: 'row',
            rq: true,
            col: true,
            en: 'Row',
            ti: '.Rowset.Row'
          }]
      }, {
        ln: 'GetData',
        tn: null,
        bti: '.RequestBaseType',
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'datasetURI',
            rq: true,
            en: 'DatasetURI'
          }, {
            n: 'attributes',
            en: 'Attributes'
          }, {
            n: 'linkageKeys',
            en: 'LinkageKeys'
          }, {
            n: 'filterColumn',
            en: 'FilterColumn',
            ti: 'AnyType'
          }, {
            n: 'filterValue',
            en: 'FilterValue',
            ti: 'AnyType'
          }, {
            n: 'xsl',
            en: 'XSL',
            ti: 'AnyType'
          }, {
            n: 'aid',
            ti: 'Boolean',
            an: {
              lp: 'aid'
            },
            t: 'a'
          }]
      }, {
        ln: 'GDAS.Framework',
        tn: null,
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }, {
            n: 'describeDatasetsRequest',
            rq: true,
            en: 'DescribeDatasetsRequest',
            ti: '.DescribeDatasetsRequest'
          }, {
            n: 'dataset',
            rq: true,
            en: 'Dataset',
            ti: '.GDAS.Framework.Dataset'
          }]
      }, {
        ln: 'Values',
        tn: null,
        ps: [{
            n: 'nominal',
            rq: true,
            en: 'Nominal',
            ti: '.Nominal'
          }, {
            n: 'ordinal',
            rq: true,
            en: 'Ordinal',
            ti: '.Ordinal'
          }, {
            n: 'count',
            rq: true,
            en: 'Count',
            ti: '.Count'
          }, {
            n: 'measure',
            rq: true,
            en: 'Measure',
            ti: '.Measure'
          }]
      }, {
        ln: 'Framework',
        tn: null,
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }, {
            n: 'dataset',
            rq: true,
            en: 'Dataset',
            ti: '.Dataset'
          }]
      }, {
        ln: 'AbstractType',
        ps: [{
            n: 'otherAttributes',
            t: 'aa'
          }, {
            n: 'content',
            col: true,
            typed: false,
            t: 'ae'
          }]
      }, {
        ln: 'TjsCapabilitiesType.Languages',
        tn: null,
        ps: [{
            n: 'language',
            rq: true,
            col: true,
            en: {
              lp: 'Language',
              ns: 'http:\/\/www.opengis.net\/ows\/1.1'
            },
            ti: 'Language'
          }]
      }, {
        ln: 'JoinDataResponse.Status',
        tn: null,
        ps: [{
            n: 'accepted',
            rq: true,
            en: 'Accepted',
            ti: 'AnyType'
          }, {
            n: 'completed',
            rq: true,
            en: 'Completed',
            ti: 'AnyType'
          }, {
            n: 'failed',
            rq: true,
            en: 'Failed',
            ti: '.JoinDataResponse.Status.Failed'
          }, {
            n: 'href',
            rq: true,
            an: {
              lp: 'href',
              ns: 'http:\/\/www.w3.org\/1999\/xlink'
            },
            t: 'a'
          }, {
            n: 'creationTime',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'creationTime'
            },
            t: 'a'
          }]
      }, {
        ln: 'SpatialFrameworks',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            col: true,
            en: 'Framework',
            ti: '.SpatialFrameworks.Framework'
          }]
      }, {
        ln: 'JoinData.AttributeData',
        tn: null,
        ps: [{
            n: 'getDataURL',
            rq: true,
            en: 'GetDataURL'
          }, {
            n: 'getDataXML',
            rq: true,
            en: 'GetDataXML',
            ti: '.JoinData.AttributeData.GetDataXML'
          }]
      }, {
        ln: 'JoinAbilities',
        tn: null,
        ps: [{
            n: 'spatialFrameworks',
            rq: true,
            en: 'SpatialFrameworks',
            ti: '.SpatialFrameworks'
          }, {
            n: 'attributeLimit',
            rq: true,
            en: 'AttributeLimit',
            ti: 'PositiveInteger'
          }, {
            n: 'outputMechanisms',
            rq: true,
            en: 'OutputMechanisms',
            ti: '.OutputMechanismsType'
          }, {
            n: 'outputStylings',
            en: 'OutputStylings',
            ti: '.JoinAbilities.OutputStylings'
          }, {
            n: 'classificationSchemaURL',
            en: 'ClassificationSchemaURL',
            ti: 'AnyType'
          }, {
            n: 'updateSupported',
            rq: true,
            ti: 'Boolean',
            an: {
              lp: 'updateSupported'
            },
            t: 'a'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'DatasetDescriptions',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            col: true,
            en: 'Framework',
            ti: '.DatasetDescriptions.Framework'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'GetCapabilities',
        tn: null,
        ps: [{
            n: 'acceptVersions',
            en: 'AcceptVersions',
            ti: '.GetCapabilities.AcceptVersions'
          }, {
            n: 'sections',
            en: 'Sections',
            ti: 'OWS_1_1_0.SectionsType'
          }, {
            n: 'acceptFormats',
            en: 'AcceptFormats',
            ti: 'OWS_1_1_0.AcceptFormatsType'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'language',
            ti: 'AnySimpleType',
            an: {
              lp: 'language'
            },
            t: 'a'
          }, {
            n: 'updateSequence',
            an: {
              lp: 'updateSequence'
            },
            t: 'a'
          }]
      }, {
        ln: 'TjsCapabilitiesType.WSDL',
        tn: null,
        ps: [{
            n: 'href',
            rq: true,
            an: {
              lp: 'href',
              ns: 'http:\/\/www.w3.org\/1999\/xlink'
            },
            t: 'a'
          }]
      }, {
        ln: 'Nominal.Classes.Value',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            en: 'Identifier'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'color',
            ti: 'AnySimpleType',
            an: {
              lp: 'color'
            },
            t: 'a'
          }]
      }, {
        ln: 'Ordinal',
        tn: null,
        ps: [{
            n: 'classes',
            en: 'Classes',
            ti: '.Ordinal.Classes'
          }, {
            n: 'exceptions',
            en: 'Exceptions',
            ti: '.NominalOrdinalExceptions'
          }]
      }, {
        ln: 'DatasetDescriptions.Framework.Dataset',
        tn: null,
        ps: [{
            n: 'datasetURI',
            rq: true,
            en: 'DatasetURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'describeDataRequest',
            rq: true,
            en: 'DescribeDataRequest',
            ti: '.DescribeDataRequest'
          }]
      }, {
        ln: 'DescribeKey',
        tn: null,
        bti: '.RequestBaseType',
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }]
      }, {
        ln: 'Columnset.Attributes',
        tn: null,
        ps: [{
            n: 'column',
            rq: true,
            col: true,
            en: 'Column',
            ti: '.Columnset.Attributes.Column'
          }]
      }, {
        ln: 'JoinDataResponse.Status.Failed',
        tn: null
      }, {
        ln: 'JoinData.MapStyling',
        tn: null,
        ps: [{
            n: 'stylingIdentifier',
            rq: true,
            en: 'StylingIdentifier',
            ti: 'AnyType'
          }, {
            n: 'stylingURL',
            rq: true,
            en: 'StylingURL'
          }]
      }, {
        ln: 'Columnset.FrameworkKey',
        tn: null,
        ps: [{
            n: 'column',
            rq: true,
            col: true,
            en: 'Column',
            ti: '.Columnset.FrameworkKey.Column'
          }, {
            n: 'relationship',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'relationship'
            },
            t: 'a'
          }, {
            n: 'complete',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'complete'
            },
            t: 'a'
          }]
      }, {
        ln: 'RequestBaseType',
        ps: [{
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'language',
            an: {
              lp: 'language'
            },
            t: 'a'
          }]
      }, {
        ln: 'Measure',
        tn: null,
        ps: [{
            n: 'uom',
            rq: true,
            en: 'UOM',
            ti: '.UOM'
          }, {
            n: 'uncertainty',
            en: 'Uncertainty',
            ti: '.Uncertainty'
          }, {
            n: 'exceptions',
            en: 'Exceptions',
            ti: '.MeasureCountExceptions'
          }]
      }, {
        ln: 'Rowset.Row',
        tn: null,
        ps: [{
            n: 'k',
            rq: true,
            col: true,
            en: 'K',
            ti: '.K'
          }, {
            n: 'v',
            rq: true,
            col: true,
            en: 'V',
            ti: '.Rowset.Row.V'
          }]
      }, {
        ln: 'Nominal',
        tn: null,
        ps: [{
            n: 'classes',
            en: 'Classes',
            ti: '.Nominal.Classes'
          }, {
            n: 'exceptions',
            en: 'Exceptions',
            ti: '.NominalOrdinalExceptions'
          }]
      }, {
        ln: 'DescribeFrameworkKeyType.Rowset',
        tn: null,
        ps: [{
            n: 'row',
            rq: true,
            col: true,
            en: 'Row',
            ti: '.DescribeFrameworkKeyType.Rowset.Row'
          }]
      }, {
        ln: 'SpatialFrameworks.Framework',
        tn: null,
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }]
      }, {
        ln: 'Nominal.Classes',
        tn: null,
        ps: [{
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'value',
            rq: true,
            col: true,
            en: 'Value',
            ti: '.Nominal.Classes.Value'
          }]
      }, {
        ln: 'MeasureCountExceptions',
        ps: [{
            n: '_null',
            rq: true,
            col: true,
            en: 'Null',
            ti: '.MeasureCountExceptions.Null'
          }]
      }, {
        ln: 'FrameworkDescriptions.Framework',
        tn: null,
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }, {
            n: 'describeDatasetsRequest',
            rq: true,
            en: 'DescribeDatasetsRequest',
            ti: '.DescribeDatasetsRequest'
          }]
      }, {
        ln: 'NominalOrdinalExceptions',
        ps: [{
            n: '_null',
            rq: true,
            col: true,
            en: 'Null',
            ti: '.NominalOrdinalExceptions.Null'
          }]
      }, {
        ln: 'Ordinal.Classes.Value',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            en: 'Identifier'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'rank',
            rq: true,
            ti: 'NonNegativeInteger',
            an: {
              lp: 'rank'
            },
            t: 'a'
          }, {
            n: 'color',
            ti: 'AnySimpleType',
            an: {
              lp: 'color'
            },
            t: 'a'
          }]
      }, {
        ln: 'Styling',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            en: 'Identifier'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract'
          }, {
            n: 'reference',
            rq: true,
            en: 'Reference'
          }, {
            n: 'schema',
            en: 'Schema'
          }]
      }, {
        ln: 'DatasetDescriptions.Framework',
        tn: null,
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'frameworkKey',
            rq: true,
            en: 'FrameworkKey',
            ti: '.FrameworkKey'
          }, {
            n: 'boundingCoordinates',
            rq: true,
            en: 'BoundingCoordinates',
            ti: '.BoundingCoordinates'
          }, {
            n: 'describeDatasetsRequest',
            rq: true,
            en: 'DescribeDatasetsRequest',
            ti: '.DescribeDatasetsRequest'
          }, {
            n: 'dataset',
            rq: true,
            col: true,
            en: 'Dataset',
            ti: '.DatasetDescriptions.Framework.Dataset'
          }]
      }, {
        ln: 'DescribeFrameworks',
        tn: null,
        bti: '.RequestBaseType',
        ps: [{
            n: 'frameworkURI',
            en: 'FrameworkURI'
          }]
      }, {
        ln: 'UOM',
        tn: null,
        ps: [{
            n: 'shortForm',
            rq: true,
            en: 'ShortForm',
            ti: 'AnyType'
          }, {
            n: 'longForm',
            rq: true,
            en: 'LongForm',
            ti: 'AnyType'
          }, {
            n: 'reference',
            an: {
              lp: 'reference',
              ns: 'http:\/\/www.opengis.net\/ows\/1.1'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinDataResponse',
        tn: null,
        ps: [{
            n: 'status',
            rq: true,
            en: 'Status',
            ti: '.JoinDataResponse.Status'
          }, {
            n: 'dataInputs',
            rq: true,
            en: 'DataInputs',
            ti: '.JoinDataResponse.DataInputs'
          }, {
            n: 'joinedOutputs',
            rq: true,
            en: 'JoinedOutputs',
            ti: '.JoinDataResponse.JoinedOutputs'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'Columnset.Attributes.Column',
        tn: null,
        ps: [{
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'values',
            rq: true,
            en: 'Values',
            ti: '.Values'
          }, {
            n: 'getDataRequest',
            rq: true,
            en: 'GetDataRequest',
            ti: '.GetDataRequest'
          }, {
            n: 'purpose',
            rq: true,
            an: {
              lp: 'purpose'
            },
            t: 'a'
          }, {
            n: 'name',
            rq: true,
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'length',
            rq: true,
            ti: 'NonNegativeInteger',
            an: {
              lp: 'length'
            },
            t: 'a'
          }, {
            n: 'decimals',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'decimals'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinDataResponse.JoinedOutputs.Output.Resource.Parameter',
        tn: null,
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'name',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'Ordinal.Classes',
        tn: null,
        ps: [{
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'value',
            rq: true,
            col: true,
            en: 'Value',
            ti: '.Ordinal.Classes.Value'
          }]
      }, {
        ln: 'TjsCapabilitiesType',
        tn: 'tjsCapabilitiesType',
        ps: [{
            n: 'serviceIdentification',
            en: {
              lp: 'ServiceIdentification',
              ns: 'http:\/\/www.opengis.net\/ows\/1.1'
            },
            ti: 'OWS_1_1_0.ServiceIdentification'
          }, {
            n: 'serviceProvider',
            en: {
              lp: 'ServiceProvider',
              ns: 'http:\/\/www.opengis.net\/ows\/1.1'
            },
            ti: 'OWS_1_1_0.ServiceProvider'
          }, {
            n: 'operationsMetadata',
            en: {
              lp: 'OperationsMetadata',
              ns: 'http:\/\/www.opengis.net\/ows\/1.1'
            },
            ti: 'OWS_1_1_0.OperationsMetadata'
          }, {
            n: 'languages',
            en: 'Languages',
            ti: '.TjsCapabilitiesType.Languages'
          }, {
            n: 'wsdl',
            en: 'WSDL',
            ti: '.TjsCapabilitiesType.WSDL'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'updateSequence',
            an: {
              lp: 'updateSequence'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'Count',
        tn: null,
        ps: [{
            n: 'uom',
            rq: true,
            en: 'UOM',
            ti: '.UOM'
          }, {
            n: 'uncertainty',
            en: 'Uncertainty',
            ti: '.Uncertainty'
          }, {
            n: 'exceptions',
            en: 'Exceptions',
            ti: '.MeasureCountExceptions'
          }]
      }, {
        ln: 'DescribeDatasetsRequest',
        tn: null,
        ps: [{
            n: 'href',
            rq: true,
            an: {
              lp: 'href',
              ns: 'http:\/\/www.w3.org\/1999\/xlink'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinDataResponse.JoinedOutputs.Output.ExceptionReport',
        tn: null,
        ps: [{
            n: 'exception',
            rq: true,
            en: {
              lp: 'Exception',
              ns: 'http:\/\/www.opengis.net\/ows\/1.1'
            },
            ti: 'OWS_1_1_0.ExceptionType'
          }]
      }, {
        ln: 'GDAS',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            en: 'Framework',
            ti: '.GDAS.Framework'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinData.AttributeData.GetDataXML',
        tn: null,
        ps: [{
            n: 'frameworkURI',
            rq: true,
            en: 'FrameworkURI'
          }, {
            n: 'datasetURI',
            rq: true,
            en: 'DatasetURI'
          }, {
            n: 'attributes',
            en: 'Attributes'
          }, {
            n: 'linkageKeys',
            en: 'LinkageKeys'
          }, {
            n: 'getDataHost',
            an: {
              lp: 'getDataHost'
            },
            t: 'a'
          }, {
            n: 'language',
            an: {
              lp: 'language'
            },
            t: 'a'
          }]
      }, {
        ln: 'Dataset',
        tn: null,
        ps: [{
            n: 'datasetURI',
            rq: true,
            en: 'DatasetURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'columnset',
            rq: true,
            en: 'Columnset',
            ti: '.Columnset'
          }, {
            n: 'rowset',
            rq: true,
            en: 'Rowset',
            ti: '.Rowset'
          }]
      }, {
        ln: 'Columnset.FrameworkKey.Column',
        tn: null,
        ps: [{
            n: 'name',
            rq: true,
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'length',
            rq: true,
            ti: 'NonNegativeInteger',
            an: {
              lp: 'length'
            },
            t: 'a'
          }, {
            n: 'decimals',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'decimals'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinDataResponse.JoinedOutputs.Output',
        tn: null,
        ps: [{
            n: 'mechanism',
            rq: true,
            en: 'Mechanism',
            ti: '.Mechanism'
          }, {
            n: 'resource',
            rq: true,
            en: 'Resource',
            ti: '.JoinDataResponse.JoinedOutputs.Output.Resource'
          }, {
            n: 'exceptionReport',
            rq: true,
            en: 'ExceptionReport',
            ti: '.JoinDataResponse.JoinedOutputs.Output.ExceptionReport'
          }]
      }, {
        ln: 'DescribeFrameworkKeyType.Rowset.Row',
        tn: null,
        ps: [{
            n: 'k',
            rq: true,
            col: true,
            en: 'K',
            ti: '.K'
          }, {
            n: 'title',
            en: 'Title'
          }]
      }, {
        ln: 'FrameworkKey.Column',
        tn: null,
        ps: [{
            n: 'name',
            rq: true,
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'length',
            rq: true,
            ti: 'NonNegativeInteger',
            an: {
              lp: 'length'
            },
            t: 'a'
          }, {
            n: 'decimals',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'decimals'
            },
            t: 'a'
          }]
      }, {
        ln: 'K',
        tn: null,
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'aid',
            ti: 'AnySimpleType',
            an: {
              lp: 'aid'
            },
            t: 'a'
          }]
      }, {
        ln: 'GDAS.Framework.Dataset',
        tn: null,
        ps: [{
            n: 'datasetURI',
            rq: true,
            en: 'DatasetURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'describeDataRequest',
            rq: true,
            en: 'DescribeDataRequest',
            ti: '.DescribeDataRequest'
          }, {
            n: 'columnset',
            rq: true,
            en: 'Columnset',
            ti: '.Columnset'
          }, {
            n: 'rowset',
            rq: true,
            en: 'Rowset',
            ti: '.Rowset'
          }]
      }, {
        ln: 'DataDescriptions',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            col: true,
            en: 'Framework',
            ti: '.FrameworkDatasetDescribeDataType'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'FrameworkKeyDescription',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            en: 'Framework',
            ti: '.DescribeFrameworkKeyType'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'OutputMechanismsType',
        ps: [{
            n: 'mechanism',
            rq: true,
            col: true,
            en: 'Mechanism',
            ti: '.Mechanism'
          }]
      }, {
        ln: 'JoinDataResponse.JoinedOutputs.Output.Resource',
        tn: null,
        ps: [{
            n: 'url',
            rq: true,
            en: 'URL',
            ti: 'AnyType'
          }, {
            n: 'parameter',
            mno: 0,
            col: true,
            en: 'Parameter',
            ti: '.JoinDataResponse.JoinedOutputs.Output.Resource.Parameter'
          }]
      }, {
        ln: 'FrameworkDatasetDescribeDataType.Dataset',
        tn: null,
        ps: [{
            n: 'datasetURI',
            rq: true,
            en: 'DatasetURI'
          }, {
            n: 'organization',
            rq: true,
            en: 'Organization'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'referenceDate',
            rq: true,
            en: 'ReferenceDate',
            ti: '.ReferenceDate'
          }, {
            n: 'version',
            rq: true,
            en: 'Version'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'describeDataRequest',
            rq: true,
            en: 'DescribeDataRequest',
            ti: '.DescribeDataRequest'
          }, {
            n: 'columnset',
            rq: true,
            en: 'Columnset',
            ti: '.Columnset'
          }]
      }, {
        ln: 'GetCapabilities.AcceptVersions',
        tn: null,
        ps: [{
            n: 'version',
            rq: true,
            col: true,
            en: 'Version'
          }]
      }, {
        ln: 'ReferenceDate',
        tn: null,
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'startDate',
            an: {
              lp: 'startDate'
            },
            t: 'a'
          }]
      }, {
        ln: 'Uncertainty',
        tn: null,
        ps: [{
            n: 'value',
            t: 'v'
          }, {
            n: 'gaussian',
            rq: true,
            an: {
              lp: 'gaussian'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinData',
        tn: null,
        bti: '.RequestBaseType',
        ps: [{
            n: 'attributeData',
            rq: true,
            en: 'AttributeData',
            ti: '.JoinData.AttributeData'
          }, {
            n: 'mapStyling',
            en: 'MapStyling',
            ti: '.JoinData.MapStyling'
          }, {
            n: 'classificationURL',
            en: 'ClassificationURL',
            ti: 'AnyType'
          }, {
            n: 'update',
            an: {
              lp: 'update'
            },
            t: 'a'
          }]
      }, {
        ln: 'FrameworkDescriptions',
        tn: null,
        ps: [{
            n: 'framework',
            rq: true,
            col: true,
            en: 'Framework',
            ti: '.FrameworkDescriptions.Framework'
          }, {
            n: 'service',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'service'
            },
            t: 'a'
          }, {
            n: 'version',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'version'
            },
            t: 'a'
          }, {
            n: 'capabilities',
            rq: true,
            an: {
              lp: 'capabilities'
            },
            t: 'a'
          }, {
            n: 'lang',
            rq: true,
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinDataResponse.JoinedOutputs',
        tn: null,
        ps: [{
            n: 'output',
            rq: true,
            col: true,
            en: 'Output',
            ti: '.JoinDataResponse.JoinedOutputs.Output'
          }]
      }, {
        ln: 'DescribeData',
        tn: null,
        bti: '.RequestBaseType',
        ps: [{
            n: 'frameworkURI',
            en: 'FrameworkURI'
          }, {
            n: 'datasetURI',
            en: 'DatasetURI'
          }, {
            n: 'attributes',
            en: 'Attributes'
          }]
      }, {
        ln: 'DescribeDatasets',
        tn: null,
        bti: '.RequestBaseType',
        ps: [{
            n: 'frameworkURI',
            en: 'FrameworkURI'
          }, {
            n: 'datasetURI',
            en: 'DatasetURI'
          }]
      }, {
        ln: 'NominalOrdinalExceptions.Null',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            en: 'Identifier'
          }, {
            n: 'title',
            rq: true,
            en: 'Title'
          }, {
            n: '_abstract',
            rq: true,
            en: 'Abstract',
            ti: '.AbstractType'
          }, {
            n: 'documentation',
            en: 'Documentation'
          }, {
            n: 'color',
            ti: 'AnySimpleType',
            an: {
              lp: 'color'
            },
            t: 'a'
          }]
      }, {
        ln: 'JoinAbilities.OutputStylings',
        tn: null,
        bti: '.OutputStylingsType'
      }, {
        ln: 'DescribeDataRequest',
        tn: null,
        ps: [{
            n: 'href',
            rq: true,
            an: {
              lp: 'href',
              ns: 'http:\/\/www.w3.org\/1999\/xlink'
            },
            t: 'a'
          }]
      }, {
        t: 'enum',
        ln: 'DescribeKeyValueType',
        vs: ['DescribeKey']
      }, {
        t: 'enum',
        ln: 'RequestServiceType',
        vs: ['TJS']
      }, {
        t: 'enum',
        ln: 'VersionType',
        vs: ['1.0']
      }, {
        t: 'enum',
        ln: 'DescribeFrameworksValueType',
        vs: ['DescribeFrameworks']
      }, {
        t: 'enum',
        ln: 'DescribeJoinAbilitiesValueType',
        vs: ['DescribeJoinAbilities']
      }, {
        t: 'enum',
        ln: 'JoinDataValueType',
        vs: ['JoinData']
      }, {
        t: 'enum',
        ln: 'DescribeDataValueType',
        vs: ['DescribeData']
      }, {
        t: 'enum',
        ln: 'DescribeDatasetsValueType',
        vs: ['DescribeDatasets']
      }, {
        t: 'enum',
        ln: 'GetDataValueType',
        vs: ['GetData']
      }, {
        t: 'enum',
        ln: 'GetCapabilitiesValueType',
        vs: ['GetCapabilities']
      }],
    eis: [{
        en: 'Capabilities',
        ti: '.TjsCapabilitiesType'
      }, {
        en: 'Measure',
        ti: '.Measure'
      }, {
        en: 'Rowset',
        ti: '.Rowset'
      }, {
        en: 'FrameworkDescriptions',
        ti: '.FrameworkDescriptions'
      }, {
        en: 'Documentation'
      }, {
        en: 'Dataset',
        ti: '.Dataset'
      }, {
        en: 'DescribeDatasets',
        ti: '.DescribeDatasets'
      }, {
        en: 'BoundingCoordinates',
        ti: '.BoundingCoordinates'
      }, {
        en: 'GetDataRequest',
        ti: '.GetDataRequest'
      }, {
        en: 'Organization'
      }, {
        en: 'DataDescriptions',
        ti: '.DataDescriptions'
      }, {
        en: 'GetData',
        ti: '.GetData'
      }, {
        en: 'Attributes'
      }, {
        en: 'Abstract',
        ti: '.AbstractType'
      }, {
        en: 'DataClass'
      }, {
        en: 'Identifier'
      }, {
        en: 'DatasetDescriptions',
        ti: '.DatasetDescriptions'
      }, {
        en: 'FrameworkURI'
      }, {
        en: 'AttributeLimit',
        ti: 'PositiveInteger'
      }, {
        en: 'DescribeJoinAbilities',
        ti: '.RequestBaseType'
      }, {
        en: 'DescribeDataRequest',
        ti: '.DescribeDataRequest'
      }, {
        en: 'Values',
        ti: '.Values'
      }, {
        en: 'SpatialFrameworks',
        ti: '.SpatialFrameworks'
      }, {
        en: 'GetCapabilities',
        ti: '.GetCapabilities'
      }, {
        en: 'LinkageKeys'
      }, {
        en: 'DescribeKey',
        ti: '.DescribeKey'
      }, {
        en: 'K',
        ti: '.K'
      }, {
        en: 'Uncertainty',
        ti: '.Uncertainty'
      }, {
        en: 'JoinData',
        ti: '.JoinData'
      }, {
        en: 'Mechanism',
        ti: '.Mechanism'
      }, {
        en: 'Version'
      }, {
        en: 'GDAS',
        ti: '.GDAS'
      }, {
        en: 'ReferenceDate',
        ti: '.ReferenceDate'
      }, {
        en: 'UOM',
        ti: '.UOM'
      }, {
        en: 'Nominal',
        ti: '.Nominal'
      }, {
        en: 'Columnset',
        ti: '.Columnset'
      }, {
        en: 'JoinDataResponse',
        ti: '.JoinDataResponse'
      }, {
        en: 'DescribeFrameworks',
        ti: '.DescribeFrameworks'
      }, {
        en: 'Ordinal',
        ti: '.Ordinal'
      }, {
        en: 'FrameworkKeyDescription',
        ti: '.FrameworkKeyDescription'
      }, {
        en: 'FrameworkKey',
        ti: '.FrameworkKey'
      }, {
        en: 'Framework',
        ti: '.Framework'
      }, {
        en: 'Styling',
        ti: '.Styling'
      }, {
        en: 'DescribeDatasetsRequest',
        ti: '.DescribeDatasetsRequest'
      }, {
        en: 'JoinAbilities',
        ti: '.JoinAbilities'
      }, {
        en: 'DescribeData',
        ti: '.DescribeData'
      }, {
        en: 'Title'
      }, {
        en: 'Count',
        ti: '.Count'
      }, {
        en: 'DatasetURI'
      }]
  };
  return {
    TJS_1_0: TJS_1_0
  };
};
if (typeof define === 'function' && define.amd) {
  define([], TJS_1_0_Module_Factory);
}
else {
  var TJS_1_0_Module = TJS_1_0_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.TJS_1_0 = TJS_1_0_Module.TJS_1_0;
  }
  else {
    var TJS_1_0 = TJS_1_0_Module.TJS_1_0;
  }
}